import { FaRegular } from '../interfaces/fa-regular.interface';

export const faRegular: FaRegular = {
  angleDown: 'fa-regular fa-angle-down',
  angleLeft: 'fa-regular fa-angle-left',
  angleRight: 'fa-regular fa-angle-right',
  angleUp: 'fa-regular fa-angle-up',
  arrowLeft: 'fa-regular fa-arrow-left',
  arrowRight: 'fa-regular fa-arrow-right',
  arrowRightToBracket: 'fa-regular fa-arrow-right-to-bracket',
  arrowRotateLeft: 'fa-regular fa-arrow-rotate-left',
  arrowUpFromSquare: 'fa-regular fa-arrow-up-from-square',
  arrowUpRightFromSquare: 'fa-regular fa-arrow-up-right-from-square',
  at: 'fa-regular fa-at',
  ban: 'fa-regular fa-ban',
  banSmoking: 'fa-regular fa-ban-smoking',
  bed: 'fa-regular fa-bed',
  bell: 'fa-regular fa-bell',
  binaryCircleCheck: 'fa-regular fa-binary-circle-check',
  binaryLock: 'fa-regular fa-binary-lock',
  blanket: 'fa-regular fa-blanket',
  boltSlash: 'fa-regular fa-bolt-slash',
  brightness: 'fa-regular fa-brightness',
  cakeCandles: 'fa-regular fa-cake-candles',
  calendar: 'fa-regular fa-calendar',
  calendarCheck: 'fa-regular fa-calendar-check',
  calendarCircleUser: 'fa-regular fa-calendar-circle-user',
  calendarClock: 'fa-regular fa-calendar-clock',
  calendarPen: 'fa-regular fa-calendar-pen',
  calendarPlus: 'fa-regular fa-calendar-plus',
  calendarXmark: 'fa-regular fa-calendar-xmark',
  camera: 'fa-regular fa-camera',
  cameraViewfinder: 'fa-regular fa-camera-viewfinder',
  car: 'fa-regular fa-car',
  check: 'fa-regular fa-check',
  checkCircle: 'fa-regular fa-check-circle',
  checkToSlot: 'fa-regular fa-check-to-slot',
  chevronDown: 'fa-regular fa-chevron-down',
  chevronLeft: 'fa-regular fa-chevron-left',
  chevronRight: 'fa-regular fa-chevron-right',
  chevronUp: 'fa-regular fa-chevron-up',
  circle: 'fa-regular fa-circle',
  circleExclamation: 'fa-regular fa-circle-exclamation',
  circleInfo: 'fa-regular fa-circle-info',
  circleParking: 'fa-regular fa-circle-parking',
  circleQuestion: 'fa-regular fa-circle-question',
  circleUser: 'fa-regular fa-circle-user',
  circleXmark: 'fa-regular fa-circle-xmark',
  clockEleven: 'fa-regular fa-clock-eleven',
  clockOne: 'fa-regular fa-clock-one',
  clockThree: 'fa-regular fa-clock-three',
  copy: 'fa-regular fa-copy',
  couch: 'fa-regular fa-couch',
  creditCard: 'fa-regular fa-credit-card',
  doorClosed: 'fa-regular fa-door-closed',
  doorOpen: 'fa-regular fa-door-open',
  building: 'fa-regular fa-building',
  download: 'fa-regular fa-download',
  envelop: 'fa-regular fa-envelope',
  envelope: 'fa-regular fa-envelope',
  eye: 'fa-regular fa-eye',
  eyeSlash: 'fa-regular fa-eye-slash',
  faceShush: 'fa-regular fa-face-shush',
  faceViewfinder: 'fa-regular fa-face-viewfinder',
  fileCertificate: 'fa-regular fa-file-certificate',
  fileInvoice: 'fa-regular fa-file-invoice',
  garageCar: 'fa-regular fa-garage-car',
  gear: 'fa-regular fa-gear',
  globe: 'fa-regular fa-globe',
  hashtagLock: 'fa-regular fa-hashtag-lock',
  heart: 'fa-regular fa-heart',
  hotel: 'fa-regular fa-hotel',
  housePersonLeave: 'fa-regular fa-house-person-leave',
  idCard: 'fa-regular fa-id-card',
  islandTropical: 'fa-regular fa-island-tropical',
  laptop: 'fa-regular fa-laptop',
  lifeRing: 'fa-regular fa-life-ring',
  locationDot: 'fa-regular fa-location-dot',
  lockKeyhole: 'fa-regular fa-lock-keyhole',
  mapLocationDot: 'fa-regular fa-map-location-dot',
  messageExclamation: 'fa-regular fa-message-exclamation',
  messagesQuestion: 'fa-regular fa-messages-question',
  minus: 'fa-regular fa-minus',
  mobileButton: 'fa-regular fa-mobile-button',
  mobileNotch: 'fa-regular fa-mobile-notch',
  mobileScreenButton: 'fa-regular fa-mobile-screen-button',
  mugHot: 'fa-regular fa-mug-hot',
  paperPlaneTop: 'fa-regular fa-paper-plane-top',
  partyHorn: 'fa-regular fa-party-horn',
  paw: 'fa-regular fa-paw',
  penToSquare: 'fa-regular fa-pen-to-square',
  personSimple: 'fa-regular fa-person-simple',
  plus: 'fa-regular fa-plus',
  power: 'fa-regular fa-power',
  powerOff: 'fa-regular fa-power-off',
  receipt: 'fa-regular fa-receipt',
  rotateRight: 'fa-regular fa-rotate-right',
  scannerKeyboard: 'fa-regular fa-scanner-keyboard',
  shareNodes: 'fa-regular fa-share-nodes',
  shieldCheck: 'fa-regular fa-shield-check',
  shieldExclamation: 'fa-regular fa-shield-exclamation',
  shieldHalved: 'fa-regular fa-shield-halved',
  shieldVirus: 'fa-regular fa-shield-virus',
  suitcase: 'fa-regular fa-suitcase',
  suitcaseRolling: 'fa-regular fa-suitcase-rolling',
  sunglasses: 'fa-regular fa-sunglasses',
  trashCanXmark: 'fa-regular fa-trash-can-xmark',
  triangleExclamation: 'fa-regular fa-triangle-exclamation',
  user: 'fa-regular fa-user',
  userCheck: 'fa-regular fa-user-check',
  userCircle: 'fa-regular fa-user-circle',
  userClock: 'fa-regular fa-user-clock',
  userGear: 'fa-regular fa-user-gear',
  userHeadset: 'fa-regular fa-user-headset',
  userLarge: 'fa-regular fa-user-large',
  userLargeSlash: 'fa-regular fa-user-large-slash',
  userPlus: 'fa-regular fa-user-plus',
  userShield: 'fa-regular fa-user-shield',
  venusMars: 'fa-regular fa-venus-mars',
  video: 'fa-regular fa-video',
  wifi: 'fa-regular fa-wifi',
  xMark: 'fa-regular fa-xmark',
  magnifyingGlass: 'fa-regular fa-magnifying-glass',
  thumbsUp: 'fa-regular fa-thumbs-up',
  thumbsDown: 'fa-regular fa-thumbs-down',
  spinner: 'fa-regular fa-spinner',
  arrowRightFromArc: 'fa-regular fa-arrow-right-from-arc',
  arrowRightToArc: 'fa-regular fa-arrow-right-to-arc',
  bars: 'fa-regular fa-bars',
  fileShield: 'fa-regular fa-file-shield',
  houseHeart: 'fa-regular fa-house-heart',
  peoplePants: 'fa-regular fa-people-pants',
  broom: 'fa-regular fa-broom',
  print: 'fa-regular fa-print',
  dollarSign: 'fa-regular fa-dollar-sign',
  fileDownload: 'fa-regular fa-file-arrow-down',
  moneyBill: 'fa-regular fa-money-bill',
  fileLines: 'fa-regular fa-file-lines',
  percent: 'fa-regular fa-percent',
  calculator: 'fa-regular fa-calculator',
  tag: 'fa-regular fa-tag',
  clock: 'fa-regular fa-clock',
  paperclip: 'fa-regular fa-paperclip',
  portableToilet: 'fa-regular fa-toilet-portable',
  upload: 'fa-regular fa-upload',
  inputNumeric: 'fa-regular fa-input-numeric',
  users: 'fa-regular fa-users',
  networkWired: 'fa-regular fa-network-wired',
  newspaper: 'fa-regular fa-newspaper'
};
